import { render, staticRenderFns } from "./syzn.vue?vue&type=template&id=baaff47a&scoped=true&"
import script from "./syzn.vue?vue&type=script&lang=js&"
export * from "./syzn.vue?vue&type=script&lang=js&"
import style0 from "./syzn.vue?vue&type=style&index=0&id=baaff47a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaff47a",
  null
  
)

export default component.exports